import { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { useQueryParams } from "raviger";
import {
  Card,
} from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { AuthContext } from "./AccountsReducer";
import Header from '../components/Header';
import { logoutUser } from "./AccountsUtils";

const RegistrationSuccess = () => {

  return (
    <>
    <span className="mt-3 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
      <Header>
        Shelterly User Account Created
      </Header>
      <div className="row mt-1">
        <div className="col-8 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body>
              <span>User account created successfully! An access request has been submited on your behalf for admin approval. Please check your email to verify your account and set your password. Your account will be activated once you set your password, but access to the incident will be available once an administrator has approved your access request.</span>
            </Card.Body>
          </Card>
        </div>
      </div>
    </span>
    </>
  );
};

export default RegistrationSuccess;
